import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Usuario } from "../../../interfaces/usuarios/usuarios.interface";

interface userState {
  userToEdit?: Usuario;
  page: number;
  size: number;
}

const initialState: userState = {
  page: 0,
  size: 10,
};

const usuariosSlice = createSlice({
  initialState,
  name: "usuarios",
  reducers: {
    setUserToEdit: (state, action: PayloadAction<Usuario>) => {
      state.userToEdit = action.payload;
    },
    setPageTableUsers: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setSizeTableUsers: (state, action: PayloadAction<number>) => {
      state.size = action.payload;
    },
  },
});

export const { setUserToEdit, setPageTableUsers, setSizeTableUsers } =
  usuariosSlice.actions;

export default usuariosSlice.reducer;
